import { decodeQRCode } from "./decodeQRCode";

// Detect that the backend's access QR has ROTATED past the one the kiosk is showing — the fingerprint of a
// transaction the subscription never delivered (a ka-masked zombie). Compares the DECODED access id, not the
// raw bytes: two PNG renders can carry the same access id, so a byte diff alone is not a rotation. Returns
// false unless BOTH sides decode to non-null, DIFFERENT access ids (never reload on a missing baseline or an
// undecodable code).
export const detectQrDrift = async (beCode: string | null, localCode: string | null): Promise<boolean> => {
	if (!(beCode && localCode) || beCode === localCode) {
		return false;
	}
	const [beAccessId, localAccessId] = await Promise.all([decodeQRCode(beCode), decodeQRCode(localCode)]);
	return beAccessId !== null && localAccessId !== null && beAccessId !== localAccessId;
};
